import { config } from "../../config";
import { ToastProgrammatic as Toast } from 'buefy';

export const namespaced = true;

export const state = {
    appVersion: config.appVersion,
    currentAppVersion: null,
    token: "",
}

export const mutations = {
    SET_CURRENT_APP_VERSION(state, payload){
        console.log('set current app version mutation: ' + payload);
        state.currentAppVersion = payload;
    },
    ADD_TOKEN(state, payload){
        state.token = payload;
    },
    ALTER_SESSION(state, payload){
        state.sessionKey = payload;
    },
}

export const actions = {
    getCurrentAppVersion(context){
        
        let url = config.currentVersionIndicatorUrl;
        let requestOptions = {
            method: 'GET'
        };
        fetch(url, requestOptions)
            .then(response => {
                let version = response.headers.get('TripCircuit-Version');
                context.commit('SET_CURRENT_APP_VERSION', version);

                console.log('getCurrentAppVersion', version);
                console.log('appVersionsMatch', context.getters.appVersionsMatch);

                // Check to see if we have already performed a load
                //by looking at the "reloaded" URL parameter
                let searchParams = new URLSearchParams(window.location.search);
                let reloadedAlready = searchParams.get('reloaded');

                // Don't reload again if we've already reloaded once
                if (reloadedAlready) {
                    console.log('already reloaded');
                    return;
                }

                // Curent URL without params
                let url = window.location.href.split('?')[0];

                // URL params
                let urlParams = new URLSearchParams(window.location.search);

                // Set the reloaded URL param
                urlParams.set('reloaded', '1');
                // console.log(urlParams);

                // Set the updated URL with all the URL params
                let newUrl = url + "?" + urlParams.toString();

                // console.log(newUrl);

                // Remove some items from local storage
                // so we can start fresh
                localStorage.removeItem('loginExpireTime');
                localStorage.removeItem('vuex');

                // Load the new URL
                window.location.href = newUrl;

                

                //if (!context.getters.appVersionsMatch) {
                    //context.dispatch('refreshBrowser');
                //}

                /* if (context.getters.appVersionsMatch) {
                    Toast.open({
                        message: 'You are on the latest version!',
                        type: 'is-success'
                    })
                } else {
                    Toast.open({
                        message: 'The latest app version is ' + version,
                        type: 'is-info'
                    })
                } */
            })
            .catch(error =>  console.log('error', error));
    },
    refreshBrowser(context){
        //localStorage.removeItem('isAuthenticated');
        //localStorage.removeItem('currentAppVersion');
        localStorage.removeItem('loginExpireTime');
        localStorage.removeItem('vuex');

        let url = window.location.href;
        console.log(url);
        window.location.reload();
    },
    addToken(context, payload){
        context.commit('ADD_TOKEN', payload);
    },
    alterSession(context){
        context.commit('ALTER_SESSION');
    },
}

export const getters = {
    appVersion(state){
        return state.appVersion;
    },
    currentAppVersion(state){
        return state.currentAppVersion;
    },
    appVersionsMatch(getters){
        return getters.appVersion == getters.currentAppVersion;
    },
    getActiveUser(state, getters, rootState){
        return rootState.travellersAndTrips.profile;
    },
}